import React from 'react';
import { useSetActiveEventPanelTab } from '../../active-event-panel-tab-provider';
import { EntityPanelTab } from '../../../panels/entity-panels/tabs/entity-panel-tab';

export function EventPanelTab(props: {
    title: string;
    children: React.ReactNode;
    titleTrailingNode?: React.ReactNode;
}): React.ReactElement {
    const setActiveEventPanelTab = useSetActiveEventPanelTab();
    return (
        <EntityPanelTab
            {...props}
            errorBoundaryName="EVENT_PANEL_TAB"
            onClose={() => setActiveEventPanelTab(undefined)}
            testId="EVENT_PANEL_TAB"
        >
            {props.children}
        </EntityPanelTab>
    );
}
